const mediaTypes = Object.freeze({
  video: '0',
  image: '1'
})

export default mediaTypes

